// SEO.js

import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, type, name }) => {
  return (
    <Helmet>

        <title>{title}</title>
        <meta name='description' content={description} />



        <meta property="og:image" content="https://bulkaceramics.com/share.jpg" />

        { /* End standard metadata tags */ }
        { /* Facebook tags */ }
        <meta property="og:type" content={type} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        { /* End Facebook tags */ }
        { /* Twitter tags */ }
        <meta name="twitter:creator" content={name} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
